import { useQuery } from "@tanstack/react-query";
import { shipmentService } from "@/services/shipmentService";

/** Detail drawer only — 404 is expected for some shipment ids; never retry */
export function useShipmentDetail(id: string | null | undefined) {
  return useQuery({
    queryKey: ["shipment-detail", id],
    queryFn: async () => {
      try {
        const res = await shipmentService.getShipmentById(id!);
        return (res as { data?: unknown })?.data ?? res ?? null;
      } catch (err: unknown) {
        const status = (err as { response?: { status?: number } })?.response?.status;
        if (status === 404) return null;
        throw err;
      }
    },
    enabled: !!id,
    staleTime: 2 * 60 * 1000,
    retry: false,
  });
}
